import React, {useMemo} from 'react'

const MoreEventBox = ({data, onNavigate, date, events}) => {
  return data.title ? (
    <div
      className={`ap-typography ap-typography--xs`}
      onClick={ev => onNavigate(ev, date, events)}
      title={`${data.title} more`}
    >
      {`${data.title} more`}
    </div>
  ) : (
    <div className={`ap-typography ap-typography--xs`}></div>
  )
}

export default MoreEventBox
